"use strict";

var cov_1rg3fmnt6q = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/index.js";
  var hash = "2916bea221377f945b733b9ca22016ce28968dd6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "2916bea221377f945b733b9ca22016ce28968dd6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withAuthentication", {
  enumerable: true,
  get: function get() {
    return _withAuthentication.withAuthentication;
  }
});
Object.defineProperty(exports, "Authentication", {
  enumerable: true,
  get: function get() {
    return _Authentication.default;
  }
});
Object.defineProperty(exports, "LoginForm", {
  enumerable: true,
  get: function get() {
    return _LoginForm.LoginForm;
  }
});

var _withAuthentication = require("./withAuthentication");

var _Authentication = _interopRequireDefault(require("./Authentication"));

var _LoginForm = require("./LoginForm");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}